import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-end gap-2 mb-4" }
const _hoisted_4 = { class: "summary-chip" }
const _hoisted_5 = { class: "summary-chip" }
const _hoisted_6 = { class: "py-4 text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_opening`)) + ": $" + _toDisplayString(_ctx.formatAmount(_ctx.summary.openingBalance)), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_closing`)) + ": $" + _toDisplayString(_ctx.formatAmount(_ctx.summary.closingBalance)), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["summary-chip", Number(_ctx.summary.difference || 0) >= 0 ? 'chip-success' : 'chip-danger'])
        }, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_difference`)) + ": $" + _toDisplayString(_ctx.formatAmount(_ctx.summary.difference)), 3)
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.items,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        scroll: { x: 1450 },
        class: "text-nowrap align-middle register-history-table",
        onChange: _ctx.handleChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.no_register_history_found`)), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'user')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.getUserName(record.user)), 1)
              ], 64))
            : (column && column.key === 'opened_at')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(record.opened_at)), 1)
                ], 64))
              : (column && column.key === 'closed_at')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(record.closed_at ? _ctx.formatDate(record.closed_at) : "-"), 1)
                  ], 64))
                : (column && column.key === 'status')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: _normalizeClass(["status-badge", Number(record.status) === 1 ? 'status-open' : 'status-closed'])
                    }, _toDisplayString(Number(record.status) === 1 ? _ctx.$t(`${_ctx.i18nScope}.status_open`) : _ctx.$t(`${_ctx.i18nScope}.status_closed`)), 3))
                  : (['opening_balance','payments_cash','payments_bank','subtotal','closing_balance','difference'].includes(String(column?.key || '')))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        class: _normalizeClass(column && column.key === 'difference' ? _ctx.getDifferenceClass(record.difference) : '')
                      }, " $" + _toDisplayString(_ctx.formatAmount((record as Record<string, unknown>)[String(column?.key)])), 3))
                    : (column && column.key === 'close_note')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createTextVNode(_toDisplayString(record.close_note || "-"), 1)
                        ], 64))
                      : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "onChange"])
    ])
  ]))
}